import React from "react";
import PropTypes from "prop-types";
import Button from "./Button";
import Tooltip from "./Tooltip";
import * as types from "../../constants/ComponentConstants";

const Form = (props) => {
	const byline = props.byline
		? <span className="byline">{props.byline}</span>
		: null;

	const leftButton = props.leftButtonLabel
		? <Button onClick={props.onLeftButtonClick} text={props.leftButtonLabel} disabled={props.leftButtonDisabled} />
		: null;

	const rightButton = props.rightButtonLabel
		? <Button onClick={props.onRightButtonClick} text={props.rightButtonLabel} disabled={props.rightButtonDisabled} />
		: null;

	const rightTopButton = props.rightTopButtonLabel
		? <Button onClick={props.onRightTopButtonClick} className="o-col-3" text={props.rightTopButtonLabel} disabled={props.rightTopButtonDisabled} />
		: null;

	const isNotRequired = props.isNotRequired
		? null
		: <div className="is-required"><p>Alle velden zijn verplicht tenzij anders aangegeven</p></div>;

	const error = props.error
		? (<div className="c-form__notifications error u-clear">
			<p className="o-col-12">
				<i className="fa fa-fw fa-exclamation-circle"/>{props.error}
			</p>
		</div>)
		: null;

	const tooltip = props.tooltip
		? (<Tooltip
			text={props.tooltip}
			tooltipType={types.TOOLTIP_INFO}
			windowWidth={props.tooltipWindowWidth}
			windowAlignRight={props.tooltipWindowAlignRight}
		/>)
		: null;

	const classNameTitle = props.longTitle ? "" : (props.rightTopButtonLabel ? "o-col-9" : "title");

	return (
		<form className="c-form" name={props.name} autoComplete="off">
			<div className="c-form__header">
				<div className={classNameTitle} >
					<h2>{props.title}{tooltip}</h2>
					{byline}
				</div>
				{isNotRequired}
				{rightTopButton}
			</div>
			<div className={"c-form__body"}>
				{error}
				{props.children}
			</div>
			<div className={"c-form__actions"}>
				{leftButton}
				{rightButton}
			</div>
		</form>
	);
};

Form.propTypes = {
	name: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	tooltip: PropTypes.string,
	tooltipWindowWidth: PropTypes.number,
	tooltipWindowAlignRight: PropTypes.bool,
	byline: PropTypes.string,
	leftButtonLabel: PropTypes.string,
	leftButtonDisabled: PropTypes.bool,
	onLeftButtonClick: PropTypes.func,
	rightButtonLabel: PropTypes.string,
	rightButtonDisabled: PropTypes.bool,
	onRightButtonClick: PropTypes.func,
	rightTopButtonLabel: PropTypes.string,
	rightTopButtonDisabled: PropTypes.bool,
	onRightTopButtonClick: PropTypes.func,
	isNotRequired: PropTypes.bool,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	error: PropTypes.string,
	children: PropTypes.node,
	longTitle: PropTypes.bool
};

export default Form;
